/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { DocumentMimeTypes } from '../model/documentMimeTypes';
// @ts-ignore
import { GeneralResponse } from '../model/generalResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class DocumentsDeprecatedService {

    protected basePath = 'https://rdsap-api.quidossoftware.co.uk';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get a document associated with a report for a specific RRN, for example \&#39;SAP Worksheet\&#39;.
     * Note that this endpoint is deprecated. Please, use \&#39;/rdsap994/v1/report/{reportReferenceNumber}/document\&#39; instead.  Retrieves a document associated with a report for a specific RRN, for example \&#39;SAP Worksheet\&#39;. 
     * @param reportReferenceNumber &#x60;RdSAP Assessment Report&#x60; Number.  The Unique Id &amp; primary index for storage.  This value is globally unique.
     * @param accept In the API service, include &#x60;Accept&#x60; in the  HTTP request header. This is a CSV header with all the header types acceptable to the client. The definition of an Accept header can be found at https://www.rfc-editor.org/rfc/rfc7231#section-5.3.2.  The format of this header should be one of the defined mime-types.   To deal with **error conditions** the client should also add &#x60;application/json&#x60; to the header. For example: &#x60;application/json,application/pdf+SAP-worksheet&#x60;.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public getSapWorksheet(reportReferenceNumber: string, accept: DocumentMimeTypes, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf+SAP-worksheet' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public getSapWorksheet(reportReferenceNumber: string, accept: DocumentMimeTypes, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf+SAP-worksheet' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public getSapWorksheet(reportReferenceNumber: string, accept: DocumentMimeTypes, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf+SAP-worksheet' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public getSapWorksheet(reportReferenceNumber: string, accept: DocumentMimeTypes, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf+SAP-worksheet' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (reportReferenceNumber === null || reportReferenceNumber === undefined) {
            throw new Error('Required parameter reportReferenceNumber was null or undefined when calling getSapWorksheet.');
        }
        if (accept === null || accept === undefined) {
            throw new Error('Required parameter accept was null or undefined when calling getSapWorksheet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accept !== undefined && accept !== null) {
            localVarHeaders = localVarHeaders.set('Accept', String(accept));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/pdf+SAP-worksheet',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let localVarPath = `/v1/report/${this.configuration.encodeParam({name: "reportReferenceNumber", value: reportReferenceNumber, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/document`;
        return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
